import { render, staticRenderFns } from "./EventContact.vue?vue&type=template&id=7cc01ff5&scoped=true&"
import script from "./EventContact.vue?vue&type=script&lang=js&"
export * from "./EventContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc01ff5",
  null
  
)

export default component.exports